import React, { useState, useEffect } from 'react';
import MenuBar from './components/MenuBar';
import MainArea from './components/MainArea';
import Login from './components/Login';
import WindowScanner from './components/Windows/WindowScanner';
import WindowFileManager from './components/Windows/WindowFileManager';
import WindowPrint from './components/Windows/WindowPrint';
import { DocumentProvider } from './utils/DocumentContext';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState('');
  const [showScanner, setShowScanner] = useState(false);
  const [showFileManager, setShowFileManager] = useState(false);
  const [showPrint, setShowPrint] = useState(false);
  const [printData, setPrintData] = useState([]);

  useEffect(() => {
    const savedUsername = localStorage.getItem('username');
    if (savedUsername) {
      setIsLoggedIn(true);
      setUsername(savedUsername);
    }
  }, []);

  const handleOpenUploader = () => {
    setShowFileManager(true);
  };

  const handleOpenScanner = () => {
    setShowScanner(true);
  };

  const handleOpenPrint = (data = []) => {
    setPrintData(data);
    setShowPrint(true);
  };

  const handleCloseScanner = () => {
    setShowScanner(false);
  };

  const handleCloseFileManager = () => {
    setShowFileManager(false);
  };

  const handleClosePrint = () => {
    setShowPrint(false);
    setPrintData([]);
  };

  if (!isLoggedIn) {
    return <Login onLogin={setIsLoggedIn} onUsernameSet={setUsername} />;
  }

  return (
    <DocumentProvider>
      <div style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'Arial, sans-serif',
        margin: 0,
        padding: 0,
        minHeight: 0
      }}>
        <MenuBar
          username={username}
          onOpenUploader={handleOpenUploader}
          onOpenScanner={handleOpenScanner}
          onOpenPrint={handleOpenPrint}
          onLogout={() => {
            setIsLoggedIn(false);
            setUsername('');
            localStorage.removeItem('username');
          }}
        />

        <MainArea onOpenPrint={handleOpenPrint} />

        {/* Модальные окна */}
        {showScanner && (
          <WindowScanner onClose={handleCloseScanner} />
        )}

        {showFileManager && (
          <WindowFileManager onClose={handleCloseFileManager} />
        )}

        {showPrint && (
          <WindowPrint
            data={printData}
            onClose={handleClosePrint}
          />
        )}
      </div>
    </DocumentProvider>
  );
}

export default App;
